import Headshot from "@components/Player/Headshot";
import React from "react";
import Section from "@components/Chatbot/Summary/Section";
import DummyGPSSection from "@components/Chatbot/Summary/GPSSection.jsx";
import DummyForceplateSection from "@components/Chatbot/Summary/ForceplateSection.jsx";
import DummyTestingSection from "@components/Chatbot/Summary/TestingSection";
import { useHeadshot } from "@hooks/useHeadshot";


const ProfileSection = ({ summaryContent }) => {
    const profile = summaryContent?.profile;
    const gps = summaryContent?.gps;
    const headshotSrc = useHeadshot(profile);

    const getLatestInjury = () => {
        const injuries = profile?.injuries;
        if (!injuries || injuries.length === 0) return {
            injury_type: "N/A",
            injury_start_date: "N/A",
            injury_end_date: "N/A"
        };
        return injuries[0];
    }

    return (
        <Section
            title={"Player Profile"}
        >
            <div className={"chat-summary-player-info-container"}>
                <div className={"chat-summary-player-headshot-container"}>
                    <div style={{ width: "125px" }}>
                        {
                            (profile?.headshot || profile?.headshot_image_url) && (
                                <Headshot
                                    headshot={headshotSrc}
                                    team_logo={summaryContent?.team_logo}
                                    useOverlay={profile?.use_overlayed_headshot || false}
                                    compact={true}
                                />
                            )
                        }

                    </div>
                </div>
                <div className={"chat-summary-player-details"}>
                    <div className={"chat-summary-player-detail-row"}>
                        <p className={"chat-summary-player-detail-text"}>
                            <span className={"chat-summary-player-number"}>
                                #{profile?.number}
                            </span>
                            <span className={"chat-summary-player-name"}>
                                {profile?.full_name}
                            </span>
                            <span className={"chat-summary-player-position"}>
                                ({profile?.position})
                            </span>
                        </p>
                    </div>
                    <div className={"chat-summary-player-detail-row"}>
                        {/* Player Top Speed */}
                        <p className={"chat-summary-player-detail-text"}>
                            Top Speed: {profile?.top_speed || "N/A"} mph
                        </p>
                    </div>
                    <div className={"chat-summary-player-detail-row"}>
                        {/* Training Count */}
                        <p className={"chat-summary-player-detail-text"}>
                            Days Trained: {gps?.metadata?.trainings?.count} / {gps?.metadata?.trainings?.total}
                        </p>
                    </div>
                    <div className={"chat-summary-player-detail-row"}>
                        {/* Games Count */}
                        <p className={"chat-summary-player-detail-text"}>
                            Games Played: {gps?.metadata?.games?.count} / {gps?.metadata?.games?.total}
                        </p>
                    </div>
                </div>
                <div className={"chat-summary-player-details"}>
                    <div className={"chat-summary-player-detail-row"}>
                        {/* Injury Count */}
                        <p className={"chat-summary-player-detail-text"}>
                            Injuries: {profile?.injuries?.length}
                        </p>
                    </div>
                    <div className={"chat-summary-player-detail-row"}>
                        {/* Latest Injury */}
                        <p className={"chat-summary-player-detail-text"}>
                            Latest Injury: {profile?.injuries?.length ? getLatestInjury().injury_type : "N/A"}
                            <span style={{ fontSize: "12px", marginLeft: "10px", textAlign: "center", marginTop: "1.5px" }}>
                                ({getLatestInjury().injury_start_date} - {getLatestInjury().injury_end_date || "Present"})
                            </span>
                        </p>
                    </div>
                    <div className={"chat-summary-player-detail-row"}>
                        {/*/!* Latest Treatment *!/*/}
                        {/*<p className={"chat-summary-player-detail-text"}>*/}
                        {/*    Most Frequent Treatment: {profile?.treatments?.most_frequent?.type}*/}
                        {/*    <span style={{ fontSize: "12px", marginLeft: "10px", textAlign: "center", marginTop: "1.5px" }}>*/}
                        {/*        (Last applied on {profile?.treatments?.most_frequent?.date_last_applied})*/}
                        {/*    </span>*/}
                        {/*</p>*/}
                    </div>
                </div>
            </div>
            <div className={"chat-summary-bullets"}>
                <p style={{ fontSize: "16px", fontWeight: '500', textAlign: "left", marginBottom: 4 }}>Overall Insights: </p>
                {summaryContent?.overview?.bullets?.map((bulletObject, index) => (
                    <p key={index} className={"chat-summary-bullet"} style={{ fontSize: "14px" }}>
                        • {bulletObject?.insight || "N/A"}
                    </p>
                ))}
            </div>
        </Section>
    )
}

const SummaryCard = ({ message }) => {
    const summaryContent = message?.content?.result;

    return (
        <div className="chat-summary-card-container">
            <div className="chat-summary-header-section">
                <p className="chat-summary-header-title">
                    {summaryContent?.overview?.title || "Summary"}
                </p>
                <p className="chat-summary-header-subtitle">
                    {summaryContent?.overview?.subtitle || "Summary"}
                </p>
            </div>
            <div className="chat-summary-section chat-summary-profile-section">
                <ProfileSection summaryContent={summaryContent} />
            </div>
            <div className="chat-summary-section chat-summary-tech-stream-section">
                <DummyGPSSection summaryContent={summaryContent} />
            </div>
            <div className="chat-summary-section chat-summary-tech-stream-section">
                <DummyForceplateSection summaryContent={summaryContent} />
            </div>
            <div className="chat-summary-section chat-summary-tech-stream-section">
                <DummyTestingSection summaryContent={summaryContent} />
            </div>

        </div>
    )
}

export default SummaryCard;
